import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appDynamicContainer]',
    standalone: false
})
export class DynamicContainerDirective {
    public constructor(public viewContainerRef: ViewContainerRef) {}
}
